
<div class="space-y-6">
    @if(isLoading()) {
         <div class="text-center py-20 text-slate-500"><i class="fa-solid fa-spinner animate-spin text-3xl"></i></div>
    } @else {
        <!-- Top Stats Cards -->
         <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl relative overflow-hidden group hover:border-yellow-500/50 transition-colors">
                <div class="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                    <i class="fa-solid fa-clock text-6xl text-yellow-500"></i>
                </div>
                <p class="text-slate-400 text-sm font-medium uppercase tracking-wider">ยอดรอจ่าย (Pending)</p>
                <p class="text-4xl font-black text-yellow-400 mt-2">฿{{ stats()?.total_pending | number:'1.2-2' }}</p>
                <p class="text-xs text-slate-500 mt-1">{{ stats()?.pending_count | number }} transactions</p>
            </div>
            <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl relative overflow-hidden group hover:border-emerald-500/50 transition-colors">
                <div class="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                    <i class="fa-solid fa-check-double text-6xl text-emerald-500"></i>
                </div>
                <p class="text-slate-400 text-sm font-medium uppercase tracking-wider">จ่ายแล้ว (Paid)</p>
                <p class="text-4xl font-black text-emerald-500 mt-2">฿{{ stats()?.total_paid | number:'1.2-2' }}</p>
            </div>
             <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl flex flex-col justify-center items-center text-center">
                 <button (click)="loadData()" class="text-slate-400 hover:text-white transition-colors mb-2"><i class="fa-solid fa-rotate"></i> Refresh Data</button>
                 <p class="text-xs text-slate-500">Last updated: {{ now() | date:'HH:mm:ss' }}</p>
                 @if(isReadOnly()) {
                     <span class="mt-2 px-3 py-1 bg-blue-900/50 text-blue-300 rounded-full text-xs font-bold border border-blue-500/30">
                        <i class="fa-solid fa-eye"></i> Auditor View (Read Only)
                     </span>
                 }
            </div>
         </div>

         <!-- Controls & Views -->
         <div class="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden shadow-xl">
            <div class="p-4 border-b border-slate-800 bg-slate-950/50 flex flex-col md:flex-row justify-between items-center gap-4">
                <div class="flex items-center gap-4">
                    <h3 class="font-bold text-white flex items-center gap-2"><i class="fa-solid fa-file-invoice-dollar text-slate-400"></i> Transactions</h3>
                    
                    <!-- View Toggle -->
                    <div class="bg-slate-800 p-1 rounded-lg flex text-xs font-bold">
                        <button (click)="isGroupView.set(false)" [class]="!isGroupView() ? 'bg-slate-600 text-white shadow' : 'text-slate-400 hover:text-slate-200'" class="px-3 py-1.5 rounded transition-all">List View</button>
                        <button (click)="isGroupView.set(true)" [class]="isGroupView() ? 'bg-slate-600 text-white shadow' : 'text-slate-400 hover:text-slate-200'" class="px-3 py-1.5 rounded transition-all">Group by Clinic</button>
                    </div>
                </div>

                <div class="flex gap-2">
                    <!-- Filter Buttons -->
                    <div class="flex bg-slate-800 p-1 rounded-lg">
                        <button (click)="setFilter('PENDING')" [class]="filter() === 'PENDING' ? 'bg-yellow-600 text-white' : 'text-slate-400 hover:text-white'" class="px-3 py-1.5 rounded text-xs font-bold transition-all">Pending</button>
                        <button (click)="setFilter('PAID')" [class]="filter() === 'PAID' ? 'bg-emerald-600 text-white' : 'text-slate-400 hover:text-white'" class="px-3 py-1.5 rounded text-xs font-bold transition-all">Paid</button>
                    </div>

                    <!-- Batch Action Button -->
                    @if(selection().size > 0 && !isReadOnly()) {
                        <button (click)="openBatchPaymentModal()" class="bg-emerald-500 hover:bg-emerald-400 text-white px-4 py-1.5 rounded-lg text-xs font-bold shadow-lg animate-fade-in flex items-center gap-2">
                            <i class="fa-solid fa-check"></i> Mark Paid ({{ selection().size }})
                        </button>
                    }
                </div>
            </div>

            <!-- VIEW 1: GROUPED BY CLINIC -->
            @if(isGroupView()) {
                <div class="overflow-x-auto">
                    <table class="w-full text-left text-sm text-slate-400">
                        <thead class="bg-slate-950 text-slate-300 uppercase text-xs font-semibold">
                            <tr>
                                <th class="px-6 py-4">Payee (Clinic)</th>
                                <th class="px-6 py-4">Bank Account</th>
                                <th class="px-6 py-4 text-center">Items</th>
                                <th class="px-6 py-4 text-right">Total Amount</th>
                                <th class="px-6 py-4 text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-800">
                            @for(group of groupedLedger(); track group.payee_id) {
                                <tr class="hover:bg-slate-800/50 transition-colors">
                                    <td class="px-6 py-4 font-bold text-white">{{ group.payee_name }}</td>
                                    <td class="px-6 py-4">
                                        @if(group.bank_account) {
                                            <div class="text-xs text-slate-300">
                                                <span class="font-bold text-emerald-400">{{ group.bank_account.bankName }}</span><br>
                                                <span class="font-mono">{{ group.bank_account.accountNumber }}</span><br>
                                                <span class="text-slate-500">{{ group.bank_account.accountName }}</span>
                                            </div>
                                        } @else {
                                            <span class="text-xs text-slate-600 italic">No Bank Info</span>
                                        }
                                    </td>
                                    <td class="px-6 py-4 text-center text-slate-300">{{ group.count }}</td>
                                    <td class="px-6 py-4 text-right font-mono font-bold text-white text-lg">฿{{ group.total_amount | number:'1.2-2' }}</td>
                                    <td class="px-6 py-4 text-right">
                                        @if(filter() === 'PENDING') {
                                            @if(!isReadOnly()) {
                                                <button (click)="openGroupPaymentModal(group)" class="px-4 py-2 rounded bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-bold shadow-sm transition-all">
                                                    Pay Group
                                                </button>
                                            } @else {
                                                <span class="text-slate-500 text-xs italic">Read Only</span>
                                            }
                                        } @else {
                                            <span class="text-emerald-500 font-bold text-xs"><i class="fa-solid fa-check-circle"></i> Complete</span>
                                        }
                                    </td>
                                </tr>
                            } @empty {
                                <tr><td colspan="5" class="text-center py-20 text-slate-500">No data found.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            } 
            
            <!-- VIEW 2: INDIVIDUAL LIST -->
            @else {
                <div class="overflow-x-auto">
                    <table class="w-full text-left text-sm text-slate-400">
                        <thead class="bg-slate-950 text-slate-300 uppercase text-xs font-semibold">
                            <tr>
                                <th class="px-4 py-4 w-10">
                                    @if(filter() === 'PENDING' && !isReadOnly()) {
                                        <input type="checkbox" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()" (change)="toggleSelectAll($event)" class="rounded bg-slate-800 border-slate-600 text-emerald-500 focus:ring-emerald-500 cursor-pointer">
                                    }
                                </th>
                                <th class="px-6 py-4">Date</th>
                                <th class="px-6 py-4">Payee (Clinic)</th>
                                <th class="px-6 py-4">From (Dispensary)</th>
                                <th class="px-6 py-4 text-right">Amount</th>
                                <th class="px-6 py-4 text-center">Status</th>
                                <th class="px-6 py-4 text-center">Evidence</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-800">
                            @for(item of ledger(); track item.id) {
                                <tr class="hover:bg-slate-800/50 transition-colors" [class.bg-slate-800]="selection().has(item.id)">
                                    <td class="px-4 py-4 text-center">
                                        @if(item.status === 'PENDING' && !isReadOnly()) {
                                            <input type="checkbox" [checked]="selection().has(item.id)" (change)="toggleItem(item.id)" class="rounded bg-slate-800 border-slate-600 text-emerald-500 focus:ring-emerald-500 cursor-pointer">
                                        }
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap font-mono text-xs">{{ item.created_at | date:'dd/MM/yy HH:mm' }}</td>
                                    <td class="px-6 py-4">
                                        <div class="font-bold text-white">{{ item.payee_name }}</div>
                                        @if(item.bank_account) {
                                            <div class="text-[10px] text-emerald-400">{{ item.bank_account.bankName }} {{ item.bank_account.accountNumber }}</div>
                                        }
                                    </td>
                                    <td class="px-6 py-4 text-slate-500">{{ item.payer_name }}</td>
                                    <td class="px-6 py-4 text-right font-mono font-bold text-white">฿{{ item.amount | number:'1.2-2' }}</td>
                                    <td class="px-6 py-4 text-center">
                                        <span class="px-2 py-1 rounded text-[10px] font-bold border uppercase tracking-wider whitespace-nowrap" 
                                              [class.bg-yellow-500_10]="item.status === 'PENDING'" [class.text-yellow-400]="item.status === 'PENDING'" [class.border-yellow-500_30]="item.status === 'PENDING'"
                                              [class.bg-emerald-500_10]="item.status === 'PAID'" [class.text-emerald-400]="item.status === 'PAID'" [class.border-emerald-500_30]="item.status === 'PAID'">
                                            {{ item.status }}
                                        </span>
                                    </td>
                                    <td class="px-6 py-4 text-center">
                                        @if(item.proof_url) {
                                            <a [href]="item.proof_url" target="_blank" class="text-blue-400 hover:text-blue-300 text-xs underline"><i class="fa-solid fa-paperclip"></i> Slip</a>
                                        } @else {
                                            <span class="text-slate-600 text-xs">-</span>
                                        }
                                    </td>
                                </tr>
                            } @empty {
                                <tr><td colspan="7" class="text-center py-20 text-slate-500">No transactions found.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
         </div>
    }
</div>

<!-- PAYMENT CONFIRMATION MODAL (Only show if not ReadOnly) -->
@if(isPaymentModalOpen() && !isReadOnly()) {
    <div class="fixed inset-0 bg-black/80 flex items-center justify-center z-[200] p-4 backdrop-blur-sm animate-fade-in" (click)="closePaymentModal()">
        <div class="bg-slate-900 rounded-xl shadow-2xl w-full max-w-md border border-slate-700 overflow-hidden" (click)="$event.stopPropagation()">
            <div class="p-6 border-b border-slate-800 bg-slate-950">
                <div class="flex justify-between items-start">
                    <div>
                        <h2 class="text-xl font-bold text-white">ยืนยันการจ่ายเงิน (Mark as Paid)</h2>
                        <p class="text-xs text-slate-400 mt-1">คุณกำลังจะอนุมัติยอดเงินสำหรับ {{ selectedCount() }} รายการ</p>
                    </div>
                    <button (click)="closePaymentModal()" class="text-slate-500 hover:text-white"><i class="fa-solid fa-times text-xl"></i></button>
                </div>
            </div>
            
            <div class="p-6 space-y-6">
                <!-- Summary -->
                <div class="bg-slate-800 p-4 rounded-lg border border-slate-700 text-center">
                    <p class="text-slate-400 text-xs uppercase tracking-wider mb-1">ยอดรวมที่ต้องโอน (Total Amount)</p>
                    <p class="text-4xl font-black text-emerald-400">฿{{ selectedAmount() | number:'1.2-2' }}</p>
                </div>

                <!-- Payee Info (Show if mixed or single) -->
                <div>
                    <h4 class="text-sm font-bold text-slate-300 mb-2">ข้อมูลผู้รับเงิน (Payee Details)</h4>
                    <div class="space-y-2 max-h-32 overflow-y-auto pr-2 custom-scrollbar">
                        @for(payee of getUniquePayeesInSelection(); track payee.name) {
                            <div class="text-xs bg-slate-800/50 p-2 rounded border border-slate-700">
                                <div class="font-bold text-white">{{ payee.name }}</div>
                                @if(payee.bank) {
                                    <div class="text-emerald-400">{{ payee.bank.bankName }} - {{ payee.bank.accountNumber }}</div>
                                    <div class="text-slate-500">{{ payee.bank.accountName }}</div>
                                } @else {
                                    <div class="text-red-400 italic">ไม่พบข้อมูลธนาคาร (No Bank Info)</div>
                                }
                            </div>
                        }
                    </div>
                </div>

                <!-- Evidence Form -->
                <div class="space-y-4">
                    <div>
                        <label class="block text-xs font-bold text-slate-400 mb-1">Bank Reference ID (Optional)</label>
                        <input type="text" [(ngModel)]="paymentBankRef" placeholder="e.g. 0123456789" class="w-full bg-slate-950 border border-slate-700 rounded px-3 py-2 text-white text-sm focus:ring-2 focus:ring-emerald-500">
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-slate-400 mb-1">Upload Slip / Evidence</label>
                        <input type="file" (change)="onFileSelected($event)" accept="image/*" class="block w-full text-xs text-slate-400 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-semibold file:bg-slate-800 file:text-emerald-400 hover:file:bg-slate-700 cursor-pointer">
                    </div>
                </div>
            </div>

            <div class="p-4 bg-slate-950 border-t border-slate-800 flex justify-end gap-3">
                <button (click)="closePaymentModal()" class="px-4 py-2 bg-slate-800 text-slate-300 rounded hover:bg-slate-700 text-sm font-bold">ยกเลิก</button>
                <button (click)="confirmPayment()" [disabled]="isProcessing()" class="px-6 py-2 bg-emerald-600 text-white rounded hover:bg-emerald-500 text-sm font-bold shadow-lg disabled:opacity-50 flex items-center gap-2">
                    @if(isProcessing()) { <i class="fa-solid fa-spinner animate-spin"></i> }
                    ยืนยัน (Confirm)
                </button>
            </div>
        </div>
    </div>
}
